<script>
import iphoneIcon from '@/assets/candidate/devices/iphone.png'
import tabletIcon from '@/assets/candidate/devices/tablet.png'
import androidIcon from '@/assets/candidate/devices/android.png'
import formatDate from '@/utils/format-date-relative'

export default {
  name: 'RegisteredDevices',
  props: {
    devices: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getTitleIcon(type) {
      if (type.includes('iPhone')) {
        return iphoneIcon
      }

      if (type.includes('iPad') || type.includes('tablet')) {
        return tabletIcon
      }

      return androidIcon
    },
    formatDate,
  },
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-for="(device, index) in devices"
        :key="index"
        cols="12"
        md="6"
        xl="4"
      >
        <v-card
          class="device-card"
          :class="{ 'inactive-device': !device.isActive }"
        >
          <v-card-title class="d-flex justify-space-between align-center mb-4">
            <div class="d-flex align-center">
              <v-img
                :src="getTitleIcon(device.deviceType)"
                :alt="device.deviceType"
              />
              <span class="ml-4">{{ device.deviceType }}</span>
            </div>
            <div>
              <v-icon
                class="mr-4"
                size="30"
                :class="[device.isActive ? 'success--text' : 'error--text']"
                >{{
                  device.isActive ? 'mdi-check-circle' : 'mdi-close-circle'
                }}</v-icon
              >
              <v-icon
                size="30"
                :class="[
                  device.isPushEnabled ? 'success--text' : 'error--text',
                ]"
                >{{
                  device.isPushEnabled ? 'mdi-bell-ring' : 'mdi-bell-sleep'
                }}</v-icon
              >
            </div>
          </v-card-title>
          <v-card-text class="device-card-body">
            <div class="d-flex align-center">
              <v-icon>{{
                ['iOS', 'iPadOS'].includes(device.deviceOs)
                  ? 'mdi-apple'
                  : 'mdi-android'
              }}</v-icon>
              <p>{{ device.deviceOs }}</p>
            </div>
            <div class="d-flex align-center">
              <v-icon>mdi-apps</v-icon>
              <p>{{ device.appName }} v{{ device.appVersion }}</p>
            </div>
            <div class="d-flex align-center">
              <v-icon>mdi-clock-outline</v-icon>
              <p class="device-updated">
                {{ $t('devices.updatedLabel') }} -
                {{
                  device.dateUpdatedUtc !== null
                    ? formatDate(device.dateUpdatedUtc)
                    : $t('devices.noUpdatedDate')
                }}
              </p>
            </div>
            <div class="d-flex align-center">
              <v-icon>mdi-bell</v-icon>
              <p>
                {{ $t('devices.notificationsLabel') }} -
                <span
                  class="font-weight-medium"
                  :class="
                    device.isPushEnabled ? 'success--text' : 'error--text'
                  "
                  >{{ device.isPushEnabled ? 'Enabled' : 'Disabled' }}</span
                >
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.device-card-body {
  div {
    padding-left: 8px;
    margin-bottom: 16px;

    i {
      margin-right: 16px;
    }
  }
  p {
    margin-bottom: 0;
  }
}

.inactive-device {
  opacity: 0.6;
}
</style>
